// extracted by mini-css-extract-plugin
module.exports = {"wrap":"checkbox_wrap__2TDKT","disabled":"checkbox_disabled__1gjie","box":"checkbox_box__3jwg-","checked":"checkbox_checked__3IxkD","name":"checkbox_name__1C8my"};